export enum Resolution {
	FULL_HD = 0,
	HD_READY = 1,
}

export enum Orientation {
	LANDSCAPE = 0,
	PORTRAIT = 1,
	LANDSCAPE_FLIPPED = 2,
	PORTRAIT_FLIPPED = 3,
	AUTO = 4,
}

export interface IConnection {
	readonly connectionUid: string;
	readonly serverInstanceUid: string;
	readonly addedAt: Date;
}

export interface ICurrentTime {
	readonly time: Date;
	readonly timezone: string;
	readonly updatedAt: Date;
}
